import config from '../config';
import { PzptApiOptions } from './PzptApiOptions';
import { PzptApi } from './createPzptRequest';
import { BaseResponse, ImageData } from './shared';

interface QueryImageByCodeRequest {
  groupCode: string;
}

interface QueryImageByCodeResponse extends BaseResponse {
  data: ImageData[];
}

/**
 * 根据单个素材编码查询素材
 * @param request
 * @returns
 */
export async function queryImageByCode(request: QueryImageByCodeRequest, options?: PzptApiOptions) {
  const url = config.pzptLink + '/api/contest/getGroupItem';
  return PzptApi.fetch<QueryImageByCodeResponse>(url, request, options);
}
